import Accordion from "@mui/material/Accordion"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import { format } from "date-fns"

import Column from "../../../../../common/components/Column"
import Row from "../../../../../common/components/Row"

export const StyledAccordion = styled((props) => (
  <Accordion elevation={1} {...props} />
))(({ theme }) => ({
  borderRadius: "8px",
  padding: theme.spacing(2),
  "&.Mui-expanded": {
    marginBlock: 0,
  },
}))

export function AccordionSummaryContent({
  accordionTitle,
  subtitle,
  Icon,
  dateStr,
}) {
  return (
    <Row sx={{ gap: 2, alignItems: "center" }}>
      <AccordionSummaryIcon>{Icon}</AccordionSummaryIcon>
      <Column sx={{ gap: 0.5 }}>
        <Typography variant="h5">{accordionTitle}</Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ fontSize: "12px" }}>
            {subtitle}
          </Typography>
        )}
        <DateTypography>{formatAccordionDate(dateStr)}</DateTypography>
      </Column>
    </Row>
  )
}

const AccordionSummaryIcon = styled(Row)(({ theme }) => ({
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.colors.gray100,
  "& .MuiSvgIcon-root": {
    fill: theme.palette.colors.gray700,
    width: "16px",
    height: "16px",
  },
}))

export const AccordionDetailsContent = styled(Row)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: "8px",
  backgroundColor: theme.palette.colors.gray50,
  gap: theme.spacing(4),
}))

export const AccordionDetailsTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.colors.gray700,
  fontSize: "14px",
}))

const DateTypography = styled((props) => (
  <Typography variant="body1" {...props} />
))(({ theme }) => ({
  fontSize: "12px",
  color: theme.palette.text.secondary,
}))

function formatAccordionDate(dateStr) {
  return format(new Date(dateStr), "MMM, dd, yyy 'at' hh:mm a")
}
